import React, { Fragment } from 'react'
import Header from '../components/layouts/Header'
import Footer from '../components/layouts/Footer'
import Onboarding from '../features/onboarding/Onboarding'
import useDocumentTitle from '../hooks/useDocumentTitle';
import useCanonical from '../hooks/useCanonical';
import { Helmet } from 'react-helmet';
import { getStructuredDataBaseUrl, getStructuredDataLogoUrl } from '../utils/canonical';

const Home = () => {
    useDocumentTitle("Hire Vetted Remote Developers in 48 Hours");
    const canonicalTag = useCanonical('/');

    return (
        <>
            {canonicalTag}
            <Helmet>
                <title>Hire Top Developers | Dev-Hire</title>
                <meta name="description" content="Hire top vetted remote developers in 48 hours with Dev Hire. Enjoy flexible monthly contracts, no recruitment fees, and guaranteed quality from day one. Access elite software engineers for freelance or full-time roles, with risk-free scaling and AI-powered matching." />
                <script type="application/ld+json">
                    {`{
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "Dev-Hire",
                        "url": "${getStructuredDataBaseUrl()}",
                        "logo": "${getStructuredDataLogoUrl()}",
                        "sameAs": [
                            "https://www.linkedin.com/company/acveti",
                            "https://www.instagram.com/devhire_"
                        ],
                        "description": "Dev-Hire helps businesses hire top 3% vetted developers across React, Python, AWS, and more — with transparent pricing and fast onboarding.",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "+1-9176952300",
                            "contactType": "customer service",
                            "areaServed": "IN, US, UK, AE",
                            "availableLanguage": ["English"]
                        }
                    }`}
                </script>
                <script type="application/ld+json">
                    {`{
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        "name": "Dev-Hire",
                        "url": "${getStructuredDataBaseUrl()}",
                        "potentialAction": {
                            "@type": "SearchAction",
                            "target": "${getStructuredDataBaseUrl()}/search?query={search_term_string}",
                            "query-input": "required name=search_term_string"
                        }
                    }`}
                </script>
            </Helmet>
            <Header />
            <main>
                <h1 className="sr-only">Get Top Developers Without the Hiring Hassle</h1>
                <Onboarding />
            </main>
            <Footer />
        </>
    )
}

export default Home;